import FJArchiveUtil from './FJArchiveUtil';
import $ from 'jquery';
import FJSVGUtil from './FJSVGUtil';
import FJMathUtil from './FJMathUtil';
import FJViewConstant from '../constants/FJViewConstant';

const textSizeMap = new Map();

// 部分业务场景下需要将 dom 放在 body 下，markDom 用来替换 body 的使用
const markDom = document.createElement('div');
$(markDom)
    .css({
        position: 'fixed',
        zIndex: -1,
        opacity: 0,
    })
    .appendTo(document.body);

const FJDomUtil = {
    testView: function (views) {
        views.forEach((view, index) => {
            document.body.appendChild(view);
            view.style.setProperty('position', 'fixed');
            view.style.setProperty('left', `${index * 300}px`);
            view.style.setProperty('top', `200px`);
            view.style.setProperty('z-index', '999999999999999');
            view.style.setProperty('border', '2px solid red');
            view.style.setProperty('width', '300px');
            view.style.setProperty('background', '#000');
        });
    },

    clearView: function (view) {
        if (!view.parentNode) return;
        view.parentNode.removeChild(view);
    },
    hasOnlyTextNodes(node) {
        // 使用递归遍历子节点
        for (const childNode of node.childNodes) {
            if (childNode.nodeType === Node.TEXT_NODE) {
                // 如果是文本节点，继续检查下一个子节点
                continue;
            } else {
                // 如果发现非文本节点，则说明不只包含文本节点
                return false;
            }
        }
        // 所有子节点都是文本节点，则说明只包含文本
        return true;
    },
    /**
     * @description 获取文本节点
     * @param node
     * @returns {any|boolean}
     */
    getTextNodes(node) {
        // 如果当前节点是文本节点，返回它的父节点
        if (node.nodeType === Node.TEXT_NODE) {
            return node.parentNode;
        }

        // 如果当前节点有子节点，递归查找子节点
        if (node.hasChildNodes()) {
            for (let child of node.childNodes) {
                let result = this.getTextNodes(child);
                if (result) {
                    return result;
                }
            }
        }

        // 如果没有找到，返回null
        return null;
    },
    /**
     * @description 返回dom中的文本样式
     * @param textListDom
     * @param isFusion
     * @returns {*[]}
     */
    getTextStyleBySpanDom(textListDom, isFusion = false) {
        const textStyleList = [];

        const __addTextStyle = (info, num) => {
            for (let i = 0; i < num; i++) {
                textStyleList.push({ ...info });
            }
        };
        [...textListDom].forEach(item => {
            const spanList = $(item).find('span');
            [...spanList].forEach(span => {
                const __func = span => {
                    let num = 0;
                    if (span.innerHTML === '<br>') {
                        num = 1;
                    } else {
                        num = span.innerText.length;
                    }
                    const computedStyle = window.getComputedStyle(span);
                    // console.log('computedStyle:::', computedStyle);
                    // console.log('computedStyleOBJ:::', {
                    //     textDecorationLine: computedStyle.textDecorationLine,
                    //     textDecorationColor: computedStyle.textDecorationColor,
                    //     textDecorationStyle: computedStyle.textDecorationStyle,
                    //     textDecorationThickness: computedStyle.textDecorationThickness,
                    // });
                    const textStyleInfo = {
                        fontColor: computedStyle.color,
                        isBold: computedStyle.fontWeight === 'bold' || computedStyle.fontWeight > 500,
                        isItalic: computedStyle.fontStyle === 'italic',
                    };
                    __addTextStyle(textStyleInfo, num);
                };

                if (FJDomUtil.hasOnlyTextNodes(span) || span.innerHTML === '<br>') {
                    if (isFusion) {
                        if (span.style.caretColor) {
                            __func(span);
                        }
                    } else {
                        __func(span);
                    }
                } else if (span.innerText) {
                    // 代表着span不是纯文本节点，需要继续递归
                    const textParentNode = this.getTextNodes(span);
                    if (textParentNode && textParentNode.tagName !== 'SPAN') {
                        __func(textParentNode);
                    }
                }
            });
        });

        return textStyleList;
    },
    getTextStyleByLineDom(textListDom) {
        const textStyleList = [];

        const __addTextStyle = (info, num) => {
            for (let i = 0; i < num; i++) {
                textStyleList.push({ ...info });
            }
        };

        const computedStyle = window.getComputedStyle(textListDom[0]);
        const textStyleInfo = {
            fontColor: computedStyle.color,
            isBold: computedStyle.fontWeight === 'bold' || computedStyle.fontWeight > 500,
            isItalic: computedStyle.fontStyle === 'italic',
        };
        __addTextStyle(textStyleInfo, 1);
        return textStyleList;
    },
    getTextDataDom(textValue, options) {
        const { maxWidth, viewScale, fontBaseCss, padding = { left: 0, right: 0 }, textStyle } = options;
        let elementBox = document.createElement('div');
        $(elementBox).css({ 'vertical-align': 'bottom' });
        const addElement = document.createElement('span');
        $(addElement).css({ display: 'inline-block' });
        for (let i = 0; i < textValue.length; i++) {
            const span = document.createElement('span');
            span.innerHTML = textValue[i];
            if (textStyle[i]) {
                $(span).css({
                    color: textStyle[i]?.fontColor,
                    fontWeight: textStyle[i]?.isBold ? 'bold' : 'normal',
                    fontStyle: textStyle[i]?.isItalic ? 'italic' : 'normal',
                });
            }
            addElement.appendChild(span);
        }

        if (maxWidth === -1) return false;

        let _element = elementBox.cloneNode();
        let _addElement = addElement.cloneNode(true);

        $(_element).css({
            paddingLeft: padding.left + 'px',
            paddingRight: padding.right + 'px',
        });

        _element.appendChild(_addElement);
        $(_element).css({
            position: 'absolute',
            left: 'auto',
            top: 0,
            height: 'auto',
            zIndex: 100,
            transform: `translate(-50%, -50%) scale(${viewScale}) translate(50%, 50%)`,
            ...fontBaseCss,
            width: maxWidth / viewScale,
            // width: maxWidth / viewScale,
            background: 'red',
        });
        markDom.appendChild(_element);
        return { elementBox: _element, addElement: _addElement };
    },
    clearSelection: function () {
        if (document.selection) {
            document.selection.empty();
        } else if (document.getSelection && document.getSelection()) {
            document.getSelection().removeAllRanges();
        }
    },

    updateSpanTextNodeColor(line, color) {
        const spanList = $(line).find('span');
        [...spanList].forEach(span => {
            if (FJDomUtil.hasOnlyTextNodes(span)) {
                $(span).css({
                    color: color,
                });
            }
        });
    },

    /**
     * 计算文本长度
     *
     * @param {string} text
     * @param {object} fontInfo
     * @param {string} fontInfo.fontFamily
     * @param {number} fontInfo.fontSize
     * @param {string} fontInfo.fontStyle
     * @param {string} fontInfo.fontWeight
     * @param {object} overrideStyle
     */
    calcTextSize: function (text = '', fontInfo = {}, overrideStyle = {}) {
        const {
            fontFamily = 'Montserrat',
            fontSize = 14,
            fontStyle = 'normal',
            fontWeight = 'normal',
            lineHeight = 'inherit',
            spacing = 'inherit',
        } = fontInfo;
        const textFontStyle = { fontFamily, fontSize, fontStyle, fontWeight, lineHeight, spacing };
        const key = `${text}-${JSON.stringify(textFontStyle)}-${JSON.stringify(overrideStyle)}`;
        if (textSizeMap.has(key)) {
            return textSizeMap.get(key);
        }

        let div = document.getElementById('flexclip-calc-text');
        if (!div) {
            div = document.createElement('div');
            $(div)
                .attr('id', 'flexclip-calc-text')
                .css({
                    transform: 'scale3d(1, 1, 1)',
                    contenteditable: false,
                    display: 'inline-block',
                    zIndex: -1,
                    position: 'fixed',
                    whiteSpace: 'nowrap',
                    opacity: 0,
                    ...textFontStyle,
                    ...overrideStyle,
                })
                .appendTo(document.body);
        }
        $(div).css({ ...textFontStyle, ...overrideStyle });
        div.innerHTML = text.replace(/\s/g, '&nbsp;');
        const { width, height } = div.getBoundingClientRect();
        const size = { width, height };
        textSizeMap.set(key, size);
        return { ...size };
    },

    /**
     * 计算文本长度
     *
     * @param {*} dom
     * @param {object} overrideStyle
     */
    calcDOMSize: function (dom, overrideStyle) {
        let div = document.getElementById('flexclip-calc-dom');
        if (!div) {
            div = document.createElement('div');
            $(div)
                .attr('id', 'flexclip-calc-dom')
                .css({
                    contenteditable: false,
                    zIndex: -1,
                    position: 'fixed',
                    opacity: 0,
                    ...overrideStyle,
                })
                .appendTo(document.body);
        }

        div.appendChild(dom);
        const { width, height } = dom.getBoundingClientRect();
        div.innerHTML = '';
        return { width, height };
    },

    domToImage: async function (dom, options = {}) {
        const {
            fonts = [],
            scaleOffset = 0,
            elementSize,
            donwgradeElementSize,
            donwgradeElement,
            keepSize,
            keepTransform,
            deleteRotate,
        } = options;
        const style = {
            position: 'inherit',
            transform: '',
            left: 0,
            top: 0,
            width: 'inherit',
            height: 'inherit',
            ...(elementSize || {}),
        };

        if (keepSize) {
            delete style.width;
            delete style.height;
        }

        if (keepTransform) {
            delete style.transform;
        }

        if (deleteRotate && dom.style.transform) {
            const styles = dom.style.transform.split(' ');
            let newStyle = [];
            styles.forEach(s => {
                if (s.indexOf('rotate') === -1) newStyle.push(s);
            });
            style.transform = newStyle.join(' ');
        }

        $(dom).removeClass('u-opacity-0').css(style);
        let { width, height } = elementSize || this.calcDOMSize(dom);

        if (width === 0 || height === 0) {
            if (donwgradeElementSize && donwgradeElement) {
                width = donwgradeElementSize.width;
                height = donwgradeElementSize.height;
                $(donwgradeElement).css({ width, height });
            } else {
                throw new Error('domToImage: size is not valid!');
            }
        }

        const offset = Math.floor(Math.max(width, height) * scaleOffset);
        const size = { width: width + offset * 2, height: height + offset * 2 };

        const svg = FJArchiveUtil.getSvgWithForeignObject(size);
        const foreignObject = $(svg).find('foreignObject')[0];

        $(dom).css({ width, height, position: 'absolute', left: offset, top: offset }).appendTo(foreignObject);

        const image = await new Promise((resolve, reject) => {
            FJSVGUtil.insertFontToSvg(svg, fonts, { success: resolve, error: reject, usePoolImage: true });
        });

        if (image instanceof Image) {
            return { image, offset };
        }
        throw new Error('domToImage fail');
    },
    /**
     * @desc 获取dom计算尺寸
     * @param dom
     * @return {{width: number, height: number}}
     */
    getDomSize(dom) {
        const computedStyle = window.getComputedStyle(dom);
        const width = parseFloat(computedStyle.width);
        const height = parseFloat(computedStyle.height);
        return { width, height };
    },
    /**
     * @desc 异步克隆节点
     * @param node - 克隆的节点
     * @param useImage - 是否将canvas转换成image
     * @param {boolean} cloneStyle - 将canvas转换成image时，是否克隆style
     * @return {Promise<*>}
     */
    cloneNodeAsync: async function (node, useImage, cloneStyle = false) {
        let func = (cloneCanvas, canvas) => {
            cloneCanvas.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height);
            return cloneCanvas;
        };
        let imageFunc = function (canvas) {
            return new Promise((resolve, reject) => {
                try {
                    let image = new Image();
                    if (cloneStyle) {
                        image.style.cssText = canvas.style.cssText;
                    }
                    image.setAttribute('crossOrigin', 'anonymous');
                    image.src = canvas.toDataURL();
                    image.onload = function () {
                        resolve(image);
                    };
                    image.onerror = () => {
                        reject(image);
                    };
                } catch (e) {
                    console.log(e);
                }
            });
        };
        if (node.nodeName === 'CANVAS') {
            return func(node.cloneNode(true), node);
        } else {
            let clone = node.cloneNode(true);
            let canvases = $(node).find('canvas');
            let cloneCanvases = $(clone).find('canvas');
            let arr = [...canvases];
            let length = arr.length;
            for (let i = 0; i < length; i++) {
                if (useImage) {
                    let c = arr[i];
                    if (c.style.display === 'none') continue;
                    let cloneC = cloneCanvases[i];
                    let image = null;
                    try {
                        image = await imageFunc(c);
                    } catch (e) {}
                    if (image) {
                        $(image).css({
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                        });
                        cloneC.parentNode.replaceChild(image, cloneC);
                    }
                } else {
                    func(cloneCanvases[i], arr[i]);
                }
            }
            return clone;
        }
    },
    cloneNodeSync: function (node) {
        let func = (cloneCanvas, canvas) => {
            if (cloneCanvas.width !== 0 && cloneCanvas.height !== 0 && canvas.width !== 0 && canvas.height !== 0) {
                cloneCanvas.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height);
            }
            return cloneCanvas;
        };
        if (node.nodeName === 'CANVAS') {
            return func(node.cloneNode(true), node);
        } else {
            let clone = node.cloneNode(true);
            let canvases = $(node).find('canvas');
            let cloneCanvases = $(clone).find('canvas');
            let arr = [...canvases];
            let length = arr.length;
            for (let i = 0; i < length; i++) {
                func(cloneCanvases[i], arr[i]);
            }
            return clone;
        }
    },
    /**
     * 判断鼠标是否在预览视窗区域
     * @param {*} event
     * @returns
     */
    judgeMouseInView: function (event, view) {
        if (!event) return;
        const { clientX: x, clientY: y } = event;
        const rect = view.getBoundingClientRect();
        const { left, right, top, bottom } = rect;
        return !(x < left || x > right || y < top || y > bottom);
    },

    getFloatingPanelPosition: (viewSize, elementRect, angle = 0, floatingPanelInfo) => {
        const { size: panelSize, margin } = floatingPanelInfo;
        const centerPoint = {
            x: elementRect.x + elementRect.width / 2,
            y: elementRect.y + elementRect.height / 2,
        };
        let y;
        if (angle && angle % 180 >= 8 && angle % 180 <= 172) {
            let left_top = { x: elementRect.x, y: elementRect.y },
                right_top = { x: elementRect.x + elementRect.width, y: elementRect.y },
                left_bottom = { x: elementRect.x, y: elementRect.y + elementRect.height },
                right_bottom = { x: elementRect.x + elementRect.width, y: elementRect.y + elementRect.height };
            let n_left_top = FJMathUtil.convertPointByAngle(left_top, centerPoint, -angle),
                n_right_top = FJMathUtil.convertPointByAngle(right_top, centerPoint, -angle),
                n_left_bottom = FJMathUtil.convertPointByAngle(left_bottom, centerPoint, -angle),
                n_right_bottom = FJMathUtil.convertPointByAngle(right_bottom, centerPoint, -angle);

            let yList = [n_left_top, n_right_top, n_left_bottom, n_right_bottom],
                xList = [n_left_top, n_right_top, n_left_bottom, n_right_bottom];
            // x从大到小排列
            xList.sort((a, b) => b.x - a.x);
            // y从大到小排列
            yList.sort((a, b) => b.y - a.y);

            // 分别获得元素矩形4个点中的最小x,y值的point点和最大x,y值的point点
            let maxYPoint = yList[0],
                minYPoint = yList[3],
                maxXPoint = xList[0],
                minXPoint = xList[3];

            // 浮动面板最小的x位置，和最大的x位置,取中心点坐标进行+或-浮动面板宽度的一半
            let mixXWithFloatPanel = centerPoint.x - panelSize.width / 2,
                maxXWithFloatPanel = centerPoint.x + panelSize.width / 2;
            // 获得4个点，对应y轴的2条线段，代表浮动面板左右的2条竖线（p1,p2）和(p3,p4)
            let p1 = { x: mixXWithFloatPanel, y: minYPoint.y };
            let p2 = { x: mixXWithFloatPanel, y: centerPoint.y };
            let p3 = { x: maxXWithFloatPanel, y: minYPoint.y };
            let p4 = { x: maxXWithFloatPanel, y: centerPoint.y };

            // 当对象最小y坐标的点，在浮动面板2条垂直线中间时，面板的y的坐标为最小点坐标
            if (minYPoint.x >= p1.x && minYPoint.x <= p3.x) {
                y = minYPoint.y - panelSize.height - margin;
                if (y < 0) {
                    y = maxYPoint.y + margin;
                }
            } else {
                // 获取与最小y点相连的2条线段（minYPoint， minXPoint）（minYPoint， maxXPoint）和浮动面板左右的垂直线相交的点
                let pp1 = FJMathUtil.getCrossPoint(p1, p2, minYPoint, minXPoint);
                let pp2 = FJMathUtil.getCrossPoint(p1, p2, minYPoint, maxXPoint);
                let pp3 = FJMathUtil.getCrossPoint(p3, p4, minYPoint, minXPoint);
                let pp4 = FJMathUtil.getCrossPoint(p3, p4, minYPoint, maxXPoint);
                // 进行筛选，筛选出没有相交点的
                let pList = [pp1, pp2, pp3, pp4].filter(item => item !== false);
                // 一个保险处理，判断如果没有任何相交点，则采用放在顶部的做法
                if (pList.length === 0) {
                    y = minYPoint.y - panelSize.height - margin;
                    if (y < 0) {
                        y = maxYPoint.y + margin;
                    }
                } else {
                    // 从小到打排序，选出其中y值最小的相交点
                    pList.sort((a, b) => a.y - b.y);
                    y = pList[0].y - panelSize.height - margin;
                    if (y < 0) {
                        let length = Math.abs(pList[0].y - centerPoint.y);
                        y = centerPoint.y + length + margin;
                    }
                }
            }
        } else {
            // 获得浮动面板在上方时的y坐标
            y = elementRect.y - panelSize.height - margin;
            // 如果y坐标小于0.则将y坐标设置为下方
            if (y < 0) {
                y = elementRect.y + elementRect.height + margin;
            }
        }

        // 如果y坐标超出下方了，则为0
        if (y + panelSize.height > viewSize.height) {
            y = 0;
        }
        return {
            left: centerPoint.x,
            top: y,
        };
    },
    /**
     * @desc 获取浮动面板的宽度
     * @param element - 元素
     * @return {number}
     */
    getFloatToolBarWidth(element) {
        //  TODO： 浮动工具栏宽度更改
        let floatToolbarWidth = 160;
        if (!element) return floatToolbarWidth;

        switch (element.getType()) {
            case FJViewConstant.GRAPH_GROUP: {
                if (element.selectedElement()) {
                    if (element.selectedElement().getType() === FJViewConstant.GRAPH_TEXT_MASK) {
                        floatToolbarWidth = 192;
                    } else {
                        floatToolbarWidth = 78;
                    }
                } else {
                    floatToolbarWidth = 269;
                }
                break;
            }
            case FJViewConstant.GRAPH_SUBTITLE_TEXT: {
                floatToolbarWidth = 44;
                break;
            }
            case FJViewConstant.GRAPH_TEXT_MASK: {
                floatToolbarWidth = 254;
                break;
            }
            default:
                break;
        }

        return floatToolbarWidth;
    },
    isScrollable(dom) {
        if (!dom) return false;
        const canScrollY = dom.scrollHeight > dom.clientHeight;
        const canScrollX = dom.scrollWidth > dom.clientWidth;
        return canScrollY || canScrollX;
    },
};

export default FJDomUtil;
